<div class="kt-portlet">
    <div class="kt-portlet__head">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                Destek Talep Listesi
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-section">
            <div class="kt-section__content">

                <div class="kt-pagination  kt-pagination--brand">
                    <ul class="kt-pagination__links">
                    </ul>
                </div>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Gönüllü</th>
                                <th>Talep başlığı</th>
                                <th>Talep tipi</th>
                                <th>Oluşturulma tarihi</th>
                                <th class="text-right">İşlemler</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let request of requests;">
                                <td>{{request.displayName}}</td>
                                <td>{{request.title}}</td>
                                <td>{{getRequestType(request.requestType)}}</td>
                                <td>{{request.creationDate}}</td>
                                <td>
                                    <button class="btn btn-success mr-2"
                                        [routerLink]="['/user-request-detail/'+request.id]"><i
                                            class="fa fa-envelope"></i>Detay</button>
                                </td>
                            </tr>
                            <tr *ngIf="requests.length == 0">
                                <td colspan="3" style="text-align: center;">Aktif destek talebi bulunmamaktadır</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>